import { GroupListItem, GroupListResponse } from './group-service-types'

/**
 * Format group item from OLD backoffice API
 * No transformation needed - returns as-is from API
 */
export const formatGroup = (item: GroupListItem): GroupListItem => ({
  id: item.id,
  name: item.name,
  typegroup: item.typegroup,
  company: item.company, // OLD: string (company name)
  active: item.active, // OLD: number (0 or 1)
  deadlineAt: item.deadlineAt
})

/**
 * Format group list response from OLD backoffice API
 * OLD: {results: [], pages: 10}
 * NEW internal format: {results: [], pages: 10} - keep same structure
 */
export const formatGroupList = (response: GroupListResponse): GroupListResponse => ({
  results: response.results?.map(formatGroup) || [],
  pages: response.pages || 1
})
